// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"trainerH1_wrapper_1KpqY","tablet":"trainerH1_tablet_1ef7U","text":"trainerH1_text_lVfbZ","btn":"trainerH1_btn_1Asvc"};